<script lang="ts">
	import { flyInOnScroll } from "../utils/flyInOnScroll";
	import StaticPicture from "./Picture/StaticPicture.svelte";
	import type { ContactCardPerson } from "./ContactCardPerson.js";
	import { nbspify } from "../../../core/utils/nbspify.js";

	export let index: number;
	export let person: ContactCardPerson;

	const animationBreakpoint = 768;
	const retardAnimation = 0.2;
</script>

<div
	class="relative aspect-square w-full max-w-[36.25rem] overflow-hidden lg:max-h-[36.25rem]"
	use:flyInOnScroll={{
		delay: window.innerWidth > animationBreakpoint ? index * retardAnimation : 0,
	}}
>
	{#if person.image}
		<StaticPicture
			image={person.image}
			alt={person.name}
			width={580}
			height={580}
			imgClass="absolute inset-0 w-full h-full object-cover"
		/>
	{:else}
		<div class="bg-tertiary inset-0 h-full w-full"></div>
	{/if}
	<div
		class="absolute bottom-0 w-full bg-gradient-to-b from-white/10 to-white/90 px-11 py-8 backdrop-blur-[3px] xl:px-16 xl:py-11"
	>
		<p class="xl:text-2lg m-0 p-0 text-lg font-bold md:text-xs lg:text-lg">{nbspify(person.name)}</p>
		{#if person.description}
			<p class="xl:text-2md m-0 p-0 text-[1.125rem] font-light md:text-xs lg:text-[1.125rem]">
				{nbspify(person.description)}
			</p>
		{/if}
	</div>
</div>
